import { Fetch } from "../utils/fetch";
import {
  User,
  GroupPermission,
  Permission,
  Game,
  Deposit,
  Partner,
  Status,
  DepositType,
  Log,
  Board,
  TransferBoard,
  Machine,
  ChangeBoard,
  Scan,
  ScanType,
  BasicDataDashboard,
  BoardsDataDashboard,
  TypeGetBoardsDashboard,
  GameDataDashboard,
  ScanDataDashboard,
  PartnerDataDashboard,
  PartnerDetailedData,
  Reason,
} from "./types";
import querystring from "querystring";

// export const api = new Fetch("http://localhost:3000");
// export const api = new Fetch("http://localhost:3001");
export const api = new Fetch("https://staging.maskin.tk:3001");
// export const api = new Fetch("https://www.maskin.tk:3000");

export const login = async (username: string, password: string) => {
  return await api.post<{ access_token: string; user: User }>("auth/login", {
    username,
    password,
  });
};

export const register = async (data: {
  username: string;
  password: string;
  email: string;
  fullName: string;
}) => {
  const { fullName, username, email, password } = data;

  return await api.post<User>("auth/register", {
    username,
    password,
    email,
    fullName,
  });
};

export const createUser = async (data: {
  username: string;
  password: string;
  email: string;
  fullName: string;
  groupPermission: string;
  status: Status;
  allowPartners: number[];
  allowAllPartners: boolean;
}) => {
  const {
    fullName,
    username,
    email,
    password,
    groupPermission,
    status,
    allowAllPartners,
    allowPartners,
  } = data;

  return await api.post<User>("users/create", {
    username,
    password,
    email,
    fullName,
    groupPermission,
    status,
    allowPartners,
    allowAllPartners,
  });
};

export const updateUser = async (
  data: {
    username?: string;
    password?: string;
    email?: string;
    fullName?: string;
    groupPermission?: string;
    status?: Status;
    allowPartners?: number[];
    allowAllPartners?: boolean;
  },
  id: number
) => {
  const {
    fullName,
    username,
    email,
    password,
    groupPermission,
    status,
    allowPartners,
    allowAllPartners,
  } = data;

  return await api.put<User>(`users/${id}`, {
    username,
    password,
    email,
    fullName,
    groupPermission,
    status,
    allowPartners,
    allowAllPartners,
  });
};

export const updateProfile = async (data: {
  username?: string;
  password?: string;
  email?: string;
  fullName?: string;
}) => {
  const { fullName, username, email, password } = data;

  return await api.put<User>(`users/profile`, {
    username,
    password,
    email,
    fullName,
  });
};

export const currentUser = async () => {
  return await api.get<User>("auth/profile");
};

export const getUsers = async (limit: number, offset: number, all: boolean) => {
  return await api.get<{ data: User[]; total: number }>(
    `users?limit=${limit}&offset=${offset}&all=${all}`
  );
};

export const getUser = async (username: string) => {
  return await api.get<User>(`users/${username}`);
};

export const deleteUser = async (id: number) => {
  return await api.del(`users/${id}`);
};

export const getGroupPermissions = async (
  all: boolean,
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: GroupPermission[]; total: number }>(
    `group-permissions?limit=${limit || 100}&offset=${offset || 0}&all=${all}`
  );
};

export const deleteGroupPermission = async (id: number) => {
  return await api.del(`group-permissions/${id}`);
};

export const createGroup = async (data: {
  name: string;
  permissionsId: number[];
  status: Status;
}) => {
  const { name, permissionsId, status } = data;

  return await api.post<GroupPermission>("group-permissions/create", {
    name,
    permissionsId,
    status,
  });
};

export const updateGroup = async (
  data: {
    name?: string;
    permissionsId?: number[];
    status?: Status;
  },
  id: number
) => {
  const { name, permissionsId, status } = data;

  return await api.put<GroupPermission>(`group-permissions/${id}`, {
    name,
    permissionsId,
    status,
  });
};

export const getGroupPermission = async (id: number) => {
  return await api.get<GroupPermission>(`group-permissions/${id}`);
};

export const getPermissions = async (limit?: number, offset?: number) => {
  return await api.get<{ data: Permission[]; total: number }>(
    `permissions?limit=${limit || 100}&offset=${offset || 0}`
  );
};

export const getGames = async (
  all: boolean,
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: Game[]; total: number }>(
    `games?limit=${limit || 100}&offset=${offset || 0}&all=${all}`
  );
};

export const getGame = async (id: number) => {
  return await api.get<Game>(`games/${id}`);
};

export const createGame = async (data: {
  name: string;
  status: Status;
  obs: string;
}) => {
  const { name, status, obs } = data;

  return await api.post<Game>("games/create", {
    name,
    status,
    obs,
  });
};

export const deleteGame = async (id: number) => {
  return await api.del(`games/${id}`);
};

export const updateGame = async (
  data: {
    name?: string;
    status?: Status;
    obs?: string;
  },
  id: number
) => {
  const { name, status, obs } = data;

  return await api.put<Game>(`games/${id}`, {
    name,
    status,
    obs,
  });
};

export const getDeposits = async (
  all: boolean,
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: Deposit[]; total: number }>(
    `deposits?limit=${limit}&offset=${offset}&all=${all}`
  );
};

export const getDeposit = async (id: number) => {
  return await api.get<Deposit>(`deposits/${id}`);
};

export const createDeposit = async (data: {
  name: string;
  status: Status;
  type: DepositType;
  obs: string;
}) => {
  const { name, status, type, obs } = data;

  return await api.post<Deposit>("deposits/create", {
    name,
    status,
    type,
    obs,
  });
};

export const deleteDeposit = async (id: number) => {
  return await api.del(`deposits/${id}`);
};

export const updateDeposit = async (
  data: {
    name?: string;
    status?: Status;
    type?: DepositType;
    obs?: string;
  },
  id: number
) => {
  const { name, status, type, obs } = data;

  return await api.put<Game>(`deposits/${id}`, {
    name,
    status,
    type,
    obs,
  });
};

export const getPartners = async (
  all: boolean,
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: Partner[]; total: number }>(
    `partners?limit=${limit}&offset=${offset}&all=${all}`
  );
};

export const getPartner = async (id: number) => {
  return await api.get<Partner>(`partners/${id}`);
};

export const createPartner = async (data: {
  name: string;
  status: Status;
  commission: number;
  companyPercentage: number;
  obs: string;
}) => {
  const { name, status, commission, obs, companyPercentage } = data;

  return await api.post<Partner>("partners/create", {
    name,
    status,
    commission,
    companyPercentage,
    obs,
  });
};

export const deletePartner = async (id: number) => {
  return await api.del(`partners/${id}`);
};

export const updatePartner = async (
  data: {
    name?: string;
    status?: Status;
    commission?: number;
    companyPercentage?: number;
    obs?: string;
  },
  id: number
) => {
  const { name, status, commission, obs, companyPercentage } = data;

  return await api.put<Game>(`partners/${id}`, {
    name,
    status,
    commission,
    companyPercentage,
    obs,
  });
};

export const getLogs = async (
  limit?: number,
  offset?: number,
  where: {
    byUser?: string | null;
    period?: {
      dateInit: string | null;
      dateEnd: string | null;
    };
  } | null = null
) => {
  const data: any = {};

  if (where && where.byUser) {
    data.byuser = where.byUser;
  }
  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }
  if (limit) {
    data.limit = limit;
  }
  if (offset) {
    data.offset = offset;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<{ data: Log[]; total: number }>(`audit?${searchParams}`);
};

export const getBoards = async (
  where: {
    onlyNoApply?: boolean;
    textSearch?: string;
    partnerId?: string;
    gameId?: string;
    all?: boolean;
  },
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: Board[]; total: number }>(
    `boards?limit=${limit || 20}&offset=${offset || 0}&onlyNoApply=${
      where.onlyNoApply || false
    }&textSearch=${where.textSearch || ""}&partnerId=${
      where.partnerId || ""
    }&gameId=${where.gameId || ""}&all=${!!where.all}`
  );
};

export const getBoard = async (id: number) => {
  return await api.get<Board>(`boards/${id}`);
};

export const createBoard = async (data: {
  serial: string;
  gameId: number;
  depositId: number;
  obs: string;
  boardCreatedDate: Date;
  status: Status;
}) => {
  const { serial, gameId, depositId, obs, boardCreatedDate, status } = data;

  return await api.post<Board>("boards/create", {
    serial,
    gameId,
    depositId,
    obs,
    boardCreatedDate,
    status,
  });
};

export const createBoards = async (data: {
  count: number;
  gameId: number | null;
  depositId: number;
  obs: string;
  boardCreatedDate: Date;
  status: Status;
}) => {
  const { count, gameId, depositId, obs, boardCreatedDate, status } = data;

  return await api.post<Board>("boards/create-many", {
    count,
    gameId,
    depositId,
    obs,
    boardCreatedDate,
    status,
  });
};

export const deleteBoard = async (id: number) => {
  return await api.del(`boards/${id}`);
};

export const updateBoard = async (
  data: {
    serial?: string;
    gameId?: number;
    obs?: string;
    boardCreatedDate?: Date;
    status?: Status;
  },
  id: number
) => {
  const { serial, gameId, obs, boardCreatedDate, status } = data;

  return await api.put<Board>(`boards/${id}`, {
    serial,
    gameId,
    obs,
    boardCreatedDate,
    status,
  });
};

export const transferBoard = async (data: {
  boardsToTransfer: number[];
  newGameId: number;
  toType: "deposit" | "partner";
  toLocal: number;
  obs: string;
  transferDate: Date;
}) => {
  const {
    boardsToTransfer,
    toType,
    toLocal,
    obs,
    transferDate,
    newGameId,
  } = data;

  return await api.post<TransferBoard>(`boards/transfer`, {
    boardsToTransfer,
    newGameId,
    toType,
    toLocal,
    obs,
    transferDate,
  });
};

export const getTransferBoards = async (
  limit?: number,
  offset?: number,
  where?: {
    textSearch?: string;
    period?: {
      dateInit?: string | null;
      dateEnd?: string | null;
    };
  }
) => {
  const data: any = {};

  if (limit) {
    data.limit = limit;
  }

  if (offset) {
    data.offset = offset;
  }

  if (where && where.textSearch) {
    data.textSearch = where.textSearch;
  }

  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<{ data: TransferBoard[]; total: number }>(
    `boards/transfer?${searchParams}`
  );
};

export const getTransferBoard = async (id: number) => {
  return await api.get<TransferBoard>(`boards/transfer/${id}`);
};

export const getMachines = async (
  where: {
    onlyNoApply?: boolean;
    onlyApply?: boolean;
    textSearch?: string;
    partnerId?: string;
    gameId?: string;
    all?: boolean;
  },
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: Machine[]; total: number }>(
    `machines?limit=${limit || 20}&offset=${offset || 0}&onlyNoApply=${
      where.onlyNoApply || false
    }&onlyApply=${where.onlyApply || false}&textSearch=${
      where.textSearch || ""
    }&partnerId=${where.partnerId || ""}&gameId=${
      where.gameId || ""
    }&all=${!!where.all}`
  );
};

export const getMachine = async (id: number) => {
  return await api.get<Machine>(`machines/${id}`);
};

export const createMachine = async (data: {
  partnerId: number;
  boardId: number;
  partnerName: string;
  obs: string;
  machineCreatedDate: Date;
  status: Status;
}) => {
  const {
    partnerId,
    boardId,
    obs,
    machineCreatedDate,
    partnerName,
    status,
  } = data;

  return await api.post<Machine>("machines/create", {
    partnerId,
    boardId,
    obs,
    partnerName,
    machineCreatedDate,
    status,
  });
};

export const updateMachine = async (
  data: {
    partnerId?: number;
    obs?: string;
    machineCreatedDate?: Date;
    partnerName?: string;
    status?: Status;
  },
  id: number
) => {
  const { partnerId, obs, machineCreatedDate, partnerName, status } = data;

  return await api.put<Machine>(`machines/${id}`, {
    partnerId,
    obs,
    machineCreatedDate,
    partnerName,
    status,
  });
};

export const removeBoardOnMachine = async (id: number) => {
  return await api.post<Machine>(`machines/removeBoard/${id}`);
};

export const changeBoard = async (
  data: {
    newBoardId: number;
    obs: string;
    reasonId: number;
    changeDate: Date;
    meterCurrentEntry: number;
    meterCurrentExit: number;
  },
  id: number
) => {
  const {
    newBoardId,
    obs,
    changeDate,
    reasonId,
    meterCurrentEntry,
    meterCurrentExit,
  } = data;

  return await api.post<ChangeBoard>(`machines/changeBoard/${id}`, {
    newBoardId,
    obs,
    changeDate,
    reasonId,
    meterCurrentEntry,
    meterCurrentExit,
  });
};

export const getChangeBoards = async (
  limit?: number,
  offset?: number,
  where?: {
    partnerId?: string;
    period?: {
      dateInit?: string | null;
      dateEnd?: string | null;
    };
  }
) => {
  const data: any = {};

  if (limit) {
    data.limit = limit;
  }

  if (offset) {
    data.offset = offset;
  }

  if (where && where.partnerId) {
    data.partnerId = where.partnerId;
  }

  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<{ data: ChangeBoard[]; total: number }>(
    `machines/changeBoard?${searchParams}`
  );
};

export const getChangeBoard = async (id: number) => {
  return await api.get<ChangeBoard>(`machines/changeBoard/${id}`);
};

export const getScans = async (
  where: {
    byUser?: string;
    partnerId?: number;
    scanType: Array<"normalScanType" | "adjustmentScanType" | "surveyScanType">;
    machineId?: number;
    gameId?: number;
    period?: {
      dateInit?: string;
      dateEnd?: string;
    };
  },
  limit?: number,
  offset?: number
) => {
  const data: any = {};

  if (where && where.byUser) {
    data.byUser = where.byUser;
  }

  if (where && where.partnerId) {
    data.partnerId = where.partnerId;
  }

  if (where && where.scanType && where.scanType.includes("normalScanType")) {
    data.normalScanType = true;
  } else {
    data.normalScanType = false;
  }

  if (
    where &&
    where.scanType &&
    where.scanType.includes("adjustmentScanType")
  ) {
    data.adjustmentScanType = true;
  } else {
    data.adjustmentScanType = false;
  }

  if (where && where.scanType && where.scanType.includes("surveyScanType")) {
    data.surveyScanType = true;
  } else {
    data.surveyScanType = false;
  }

  if (where && where.machineId) {
    data.machineId = where.machineId;
  }

  if (where && where.gameId) {
    data.gameId = where.gameId;
  }

  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }
  if (limit) {
    data.limit = limit;
  }
  if (offset) {
    data.offset = offset;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<{ data: Scan[]; total: number }>(
    `scannings?${searchParams}`
  );
};

export const getScan = async (scanId: number) => {
  return await api.get<Scan>(`scannings/${scanId}`);
};

export const createScan = async (data: {
  machineId: number;
  scanType: ScanType;
  obs: string;
  meterCurrentEntry: number;
  meterCurrentExit: number;
}) => {
  const {
    machineId,
    scanType,
    obs,
    meterCurrentEntry,
    meterCurrentExit,
  } = data;

  return await api.post<Scan>("scannings/create", {
    machineId,
    scanType,
    obs,
    meterCurrentEntry,
    meterCurrentExit,
  });
};

export const updateScan = async (
  data: {
    obs?: string;
    meterCurrentEntry?: number;
    meterCurrentExit?: number;
  },
  scanId: number
) => {
  const { obs, meterCurrentEntry, meterCurrentExit } = data;

  return await api.put<Scan>(`scannings/${scanId}`, {
    obs,
    meterCurrentEntry,
    meterCurrentExit,
  });
};

export const removeScan = async (scanId: number) => {
  return await api.post<boolean>(`scannings/remove/${scanId}`);
};

export const getLastScanOnMachine = async (machineId: number) => {
  const data = await api.get<Scan>(`scannings/lastScan/${machineId}`);
  return data;
};

export const getLastScanOnBoard = async (boardId: number) => {
  const data = await api.get<Scan>(`scannings/lastScanOnBoard/${boardId}`);
  return data;
};

export const canBeUpdated = async (id: number) => {
  return await api.post<boolean>(`scannings/canBeUpdated/${id}`);
};

export const getBasicData = async () => {
  return await api.get<BasicDataDashboard>(`dashboard/getBasicData`);
};

export const getBoardsData = async () => {
  return await api.get<BoardsDataDashboard>(`dashboard/getBoardsData`);
};

export const getBoardsDashboard = async (
  type: TypeGetBoardsDashboard,
  partnerOrDepositId?: number
) => {
  if (partnerOrDepositId) {
    return await api.get<{ data: Board[]; total: number }>(
      `dashboard/getBoards?type=${type}&partnerOrDepositId=${partnerOrDepositId}`
    );
  } else {
    return await api.get<{ data: Board[]; total: number }>(
      `dashboard/getBoards?type=${type}`
    );
  }
};

export const getGamesData = async () => {
  return await api.get<GameDataDashboard[]>(`dashboard/getGamesData`);
};

export const getScansData = async (
  where: {
    partnerIds?: string[] | null;
    scanTypes?: ScanType[] | null;
    period?: {
      dateInit: string | null;
      dateEnd: string | null;
    };
    groupBy?: "all" | "date" | "partner" | "scanType" | null;
  } | null = null
) => {
  const data: any = {};

  if (where && where.partnerIds) {
    data.partnerIds = where.partnerIds;
  }
  if (where && where.scanTypes) {
    data.scanTypes = where.scanTypes;
  }
  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }
  if (where && where.groupBy) {
    data.groupBy = where.groupBy;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<ScanDataDashboard>(
    `dashboard/getScansData?${searchParams}`
  );
};

export const getPartnersData = async (
  where: {
    partnerIds?: string[] | null;
    period?: {
      dateInit: string | null;
      dateEnd: string | null;
    };
  } | null = null
) => {
  const data: any = {};

  if (where && where.partnerIds) {
    data.partnerIds = where.partnerIds;
  }
  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<PartnerDataDashboard>(
    `dashboard/getPartnersData?${searchParams}`
  );
};

export const getDetailedPartnersData = async (
  where: {
    partnerIds?: string[] | null;
    period?: {
      dateInit: string | null;
      dateEnd: string | null;
    };
  } | null = null
) => {
  const data: any = {};

  if (where && where.partnerIds) {
    data.partnerIds = where.partnerIds;
  }
  if (where && where.period && where.period.dateInit && where.period.dateEnd) {
    data.dateInit = where.period.dateInit;
    data.dateEnd = where.period.dateEnd;
  }

  const searchParams = querystring.stringify(data);

  return await api.get<PartnerDetailedData[]>(
    `dashboard/getDetailedPartnersData?${searchParams}`
  );
};

export const getReasons = async (
  all: boolean,
  limit?: number,
  offset?: number
) => {
  return await api.get<{ data: Reason[]; total: number }>(
    `reasons?limit=${limit || 100}&offset=${offset || 0}&all=${all}`
  );
};

export const createReason = async (data: { name: string; status: Status }) => {
  const { name, status } = data;

  return await api.post<Reason>("reasons/create", {
    name,
    status,
  });
};

export const updateReason = async (
  data: {
    name?: string;
    status?: Status;
  },
  id: number
) => {
  const { name, status } = data;

  return await api.put<Reason>(`reasons/${id}`, {
    name,
    status,
  });
};

export const getReason = async (id: number) => {
  return await api.get<Reason>(`reasons/${id}`);
};
